<script>
	import { Router, Route } from "svelte-routing";
	import CreateForm from "./CreateForm.svelte";
	import EditForm from "./EditForm.svelte";
	import ManageFms from "./ManageFMS/ManageFms.svelte";
</script>

<Router url="/">
	<Route path="/" component={ManageFms} />
	<Route path="/create" component={CreateForm} />
	<Route path="/edit/:id" let:params>
		<EditForm userId={params.id} />
	</Route>
</Router>
